import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import './registerServiceWorker';
import NumericOnly from './directives/numeric-only';
import router from './router';
import store from './store';
import VueMask from 'v-mask';
import Axios from 'axios';
import money from 'v-money';
import underscore from 'vue-underscore';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './assets/js/bootstrap';
import './assets/js/app/scripts';
import { IconsPlugin } from 'bootstrap-vue';
import BootstrapVue from 'bootstrap-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import ImgInputer from 'vue-img-inputer';
import 'vue-img-inputer/dist/index.css';
import VueCurrencyFilter from 'vue-currency-filter';
import VueSimpleAlert from 'vue-simple-alert';
// import ElPagination from 'element-ui/lib/pagination';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ua';
import VueEllipsis from 'vue-ellipsis';
import Skeleton from 'vue-loading-skeleton';
import Clipboard from 'v-clipboard';
import VueClipboard from 'vue-clipboard2';
import vueCurrencyDirective from 'vue-currency-directive';
import VueConfirmDialog from 'vue-confirm-dialog/src';
import VueSocialSharing from 'vue-social-sharing';
import { Auth } from '@/shared/lib/auth';
import { BroadcastClientPlugin } from '@/shared/lib/broadcast';
import { EventBusPlugin } from '@/shared/lib/event-bus';

const VueInputMask = require('vue-inputmask').default;

import { faEdit, faInfo, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

library.add(faInfo, faEdit, faTrashAlt);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueInputMask);
Vue.use(Skeleton);
Vue.use(Clipboard);
Vue.use(VueClipboard);
Vue.use(VueEllipsis);
Vue.use(VueConfirmDialog);
Vue.use(VueSocialSharing);
Vue.use(EventBusPlugin);
Vue.use(BroadcastClientPlugin);

Vue.component('ImgInputer', ImgInputer);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);


import datePicker from 'vue-bootstrap-datetimepicker';
import ElementUI from 'element-ui';

Vue.use(datePicker);
Vue.use(Vuelidate);
Vue.use(IconsPlugin);
Vue.use(BootstrapVue);
Vue.use(ElementUI, { locale });

Vue.prototype.$toast = {
  success(message) {
    Vue.prototype.$message.success(message);
  },
  error(message) {
    Vue.prototype.$message.error(message);
  },
  info(message) {
    Vue.prototype.$message.info(message);
  },
  warning(message) {
    Vue.prototype.$message.warning(message);
  },
};

Vue.use(require('vue-moment'));
Vue.use(money, { precision: 4 });
Vue.use(underscore);

Vue.use(VueSimpleAlert);
Vue.directive('currency', vueCurrencyDirective);
Vue.directive('numeric-only', NumericOnly);

Vue.use(VueCurrencyFilter,
  {
    symbol : '₴',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  });

Vue.use(VueMask, {
  placeholders: {
    Я: /[а-яА-Я]/, // cyrillic letter as a placeholder
    V: /[a-zA-Z, а-яА-Я]/,
    U: /[0-9,А-Яа-яЁёІіЇїЄє]/,
    Y: /[А-Яа-яЁёІіЇїЄєʼ\s']/,
    K: /[А-Яа-яЁёІіЇїЄє']/,
    G: /[a-zA-ZА-Яа-яЁёІіЇїЄє\s]/,
    N: /[0-9, a-zA-Z\s]/,
    M: /[0-9, a-zA-ZА-Яа-яЁёІіЇїЄє]/
  }
});
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;

Vue.prototype.$http = Axios;

// Auth не імпортує store сам (цикл імпортів через entities/insurance), тому store
// прив'язується тут — до першого запиту з токеном (loadPrivilegeTypes нижче).
Auth.bindStore(store);

import VersionCheck from '@/utils/version-check';

if (process.env.NODE_ENV !== 'development') {
  Vue.use(VersionCheck, {
    interval: 30000,
    versionFile: '/version.json',
  });
}

const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' +token;
}

Vue.filter('currencySign', function (currencyCode) {
  const currencySigns = {
    'EUR': '€',
    'USD': '$',
    'UAH': '₴'
    // Добавьте другие коды валют и соответствующие знаки здесь
  };
  return currencySigns[currencyCode] || currencyCode;
});

// Довідники з бекенду, потрібні формам ОСЦПВ ще у created(); помилка завантаження не блокує застосунок.
store.dispatch('loadPrivilegeTypes')
  .catch(error => console.error('Не вдалося завантажити довідник пільг', error))
  .finally(() => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  });
